<template>
  <div>
        <Header
          :productRequestAlert = "productRequestAlert"
        ></Header>
        <NeedCategories></NeedCategories>
  <div class="g-product-list">
    <v-container fluid class="mt-5 load">
      <div :loading="loading" :offset='20' class="infinity-panel">
        <v-layout row wrap class="products-filter">
          <div class="justify-space-between d-flex w-100 align-center group-location">
          </div>
          <div class="d-flex">
            <v-flex class="filter-middle">
              <div class="filter-tags mb-10 mt-10" v-if="checkboxCategory">
                <v-chip v-for="(subCheckbox) in checkboxCategory.subcategories"
                        :key="subCheckbox.id"
                        v-if="mainSearch.filter.includes(subCheckbox.id)"
                >
                  <span>{{ subCheckbox.displayInfo.name }} <v-icon small @click="deleteCategoryFilter(subCheckbox.id)">clear</v-icon></span>
                </v-chip>
              </div>
            </v-flex>
          </div>
          <div class="loader-selector">
            <v-progress-linear height="2" :indeterminate="productsUploadProgress" v-if="productsUploadProgress"/>
            <span class="loader-line"/>
          </div>
        </v-layout>
        <v-layout row wrap class="g-card scroll-product-sect">
          <v-flex v-if="loadedProducts && items.length === 0">
            <div class="emptyproduct">
              <img class="emptyImg mb-2" src="../assets/images/empty.svg" alt="">
              <h3 class="text-center font-weight-medium">
                {{$t('no_matching_items_found')}}
              </h3>
            </div>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 v-for="(item) in visiblePages" :key="item.label" :class="{ 'ex-height' : items.length <= 4 }"
                  class="g-product-list-item">
            <v-card>
              <router-link :to="'/need/' + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
                <v-layout class="g-item-list">
                  <div v-if="item.image" @click = "$router.push('/need/' + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-'))" class="g-card-img1" >
                    <img :src="`${ROOT_API}${item.image}`" :alt="item.displayDetails.name">
                  </div>
                  <div v-else @click = "$router.push('/need/' + item.id  + '/' + item.displayDetails.name.replace(/\s+/g, '-'))" class="g-card-img1" >
                    <img src="../assets/images/default.svg" alt="Default image">
                  </div>
                </v-layout>
              </router-link>
              <v-layout fill-height class="g-header">
                <v-flex xs12 class="product-title">
                  <router-link :to="'/products/' + item.id  + '/' + item.displayDetails.name.replace(/\s+/g, '-')" class="headline prod-title-name"> {{ item.displayDetails.name }}</router-link>
                </v-flex>
              </v-layout>
              <v-layout class="ex-address">
                <i class="icon-location"/>
                {{ (item.displayDetails && item.displayDetails.location) ? item.displayDetails.location : '' }}
              </v-layout>
              <v-layout class="ex-good-description">
                {{ item.displayDetails.description }}
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <div class="text-center">
        <v-pagination v-if="visiblePages.length > 1"
                      v-model="page"
                      :total-visible="7"
                      :length="Math.ceil(items.length/perPage)"
        ></v-pagination>
      </div>
    </v-container>
  </div>
  </div>
</template>

<script>
import Header from '../components/global/Header.vue'
import NeedCategories from '../components/categories/needCategories'
import {changeImageSize, createLocation} from '../helpers/main'
import {EventBus} from '../event-bus'
import {mapState} from 'vuex'
export default {
  name: 'Needs',
  components: {
    Header,
    NeedCategories
  },
  data: () => ({
    productRequestAlert: false,
    page: 1,
    perPage: 16,
    loadingSearch: false,
    showPreloading: false,
    loadedProducts: false,
    loading: false,
    items: [],
    ROOT_API: process.env.ROOT_API,
    productsUploadProgress: false,
    checkboxCategory: null,
    categoryIdActive: null,
    sendRequestInterval: true,
    productsSearch: {
      searchText: undefined,
      searchMove: false
    },
    productsFilter: {
      buttonGroup: [],
      productsWhereIn: [],
      firstFiltrationRun: false,
      locationId: null
    },
    productsPage: {
      itemsLoadedPages: [],
      page: 1,
      limit: 16,
      backPage: 0
    }
  }),
  created () {
    this.getNeeds()
    EventBus.$off('select-deselect-category')
    EventBus.$on('language-changed', this.languageChanged)
    EventBus.$on('select-deselect-category', this.selectedDeselectedCategory)
    this.changeFiltersLang()
  },
  computed: {
    ...mapState({
      categories: state => state.categoriesNeeds.needs,
      mainSearch: state => state.categoriesNeeds.mainSearchNeeds
    }),
    visiblePages () {
      return this.items.slice((this.page - 1) * this.perPage, this.page * this.perPage)
    }
  },
  mounted () {

  },
  methods: {
    selectedDeselectedCategory (cat) {
      if (cat.productsWhereIn.length === 0 && cat.checkboxCategory === null) {
        this.getNeeds()
      }
      this.$store.dispatch('categoriesNeeds/setSearch', {name: null})
      if (cat.productsWhereIn) {
        this.productsFilter.productsWhereIn = cat.productsWhereIn
      }
      this.checkboxCategory = cat.checkboxCategory ? cat.checkboxCategory : []
      if (cat.productsWhereIn !== undefined) {
        this.checkboxCategory = cat.checkboxCategory ? cat.checkboxCategory : []
        return this.$store.dispatch('products/getFilteredNeeds', cat.productsWhereIn).then((res) => {
          if (res.data.products) {
            this.getNeedsList(res.data.products)
          }
        }).catch(err => {
          console.error(err)
        })
      }
    },
    setProductsPageDefaultValues () {
      this.productsPage.page = 1
      this.productsPage.limit = 16
      this.productsFilter.firstFiltrationRun = true
      this.productsPage.itemsLoadedPages = [this.productsPage.page]
    },
    changeFiltersLang () {
      if (this.checkboxCategory) {
        this.categories.forEach((item, i) => {
          if (this.checkboxCategory.id === item.id) {
            this.checkboxCategory = item
          }
        })
      }
    },
    deleteCategoryFilter (subCatId) {
      let indexOf = this.productsFilter.productsWhereIn.indexOf(subCatId)
      this.productsFilter.productsWhereIn.splice(indexOf, 1)
      EventBus.$emit('delete-checkbox', {productsWhereIn: this.productsFilter.productsWhereIn})
    },
    getNeeds () {
      this.productsUploadProgress = true
      return this.$store.dispatch('products/getNeeds').then((res) => {
        this.getNeedsList(res.data.products)
      }).catch(err => {
        console.error(err)
      })
    },
    getNeedsList (products) {
      this.loadedProducts = false
      this.showPreloading = true
      let _products = []
      products.forEach(product => {
        product.image = changeImageSize(product.image, 'md')
        product.displayDetails = {}
        product.ProductTranslations.forEach(productTranslation => {
          if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            if (productTranslation.name.match(/և/)) {
              productTranslation.name = productTranslation.name.replace('և', 'եվ').replace(/,\s*$/, '')
              product.displayDetails.name = productTranslation.name
            }
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description.length > 75 ? productTranslation.description = productTranslation.description.substring(0, 75) + '...' : productTranslation.description
          } else if (!product.displayDetails.name) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description.length > 75 ? productTranslation.description = productTranslation.description.substring(0, 75) + '...' : productTranslation.description
          }
        })
        product.ProductAddresses.forEach(productAddress => {
          let addressData = productAddress.Address
          if (productAddress.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.location = createLocation(addressData)
          } else if (!product.displayDetails.location) {
            product.displayDetails.location = createLocation(addressData)
          }
        })
        _products.push(product)
      })
      let loadSetTimeouth = setTimeout(() => {
        this.items = _products
        this.productsUploadProgress = false
        this.loadedProducts = true
        this.loadingSearch = false
        this.showPreloading = false
        clearTimeout(loadSetTimeouth)
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.load{
  margin-top: 60px;
}
@import "../assets/sass/desktop/products.scss";
</style>



// WEBPACK FOOTER //
// src/views/Needs.vue